module.exports = __webpack_public_path__ + "static/media/inetcpl_1303.f331bb7d.ico";